import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Clock } from "lucide-react";
import { studio } from "@/lib/studioApi";

export const SubscriptionBanner = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    studio.get("/subscription").then(({ data }) => setState(data)).catch(() => {});
  }, []);

  if (!state || state.status === "active") return null;

  const expired = state.status === "expired";

  return (
    <div
      data-testid="subscription-banner"
      className={`mt-5 flex flex-wrap items-center gap-3 rounded-xl border border-[#E2E7F7] bg-white py-3 pl-4 pr-4 ${expired ? "shadow-[inset_3px_0_0_#E11D48]" : "shadow-[inset_3px_0_0_#F97316]"}`}
    >
      <span className={`inline-flex items-center justify-center w-8 h-8 rounded-lg ${expired ? "bg-rose-50 text-rose-600" : "bg-orange-50 text-[#F97316]"}`}>
        {expired ? <AlertTriangle className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
      </span>
      <div className="flex-1 min-w-[14rem]">
        <p className="text-sm font-semibold text-[#0F2645]">
          {expired ? "Votre essai est terminé" : `Essai gratuit — ${state.trial_days_left} jour(s) restant(s)`}
        </p>
        <p className="mt-0.5 text-xs text-[#5C6A87]">
          {expired
            ? "Activez l'abonnement pour continuer à préparer vos devis."
            : `${state.price_label || "25 € / mois par société"} ensuite, vos ouvriers inclus.`}
        </p>
      </div>
      {state.is_owner ? (
        <Link
          to="/studio/abonnement"
          data-testid="subscription-banner-cta"
          className="inline-flex h-9 items-center gap-2 rounded-xl border border-[#E2E7F7] bg-white px-4 text-xs font-semibold text-[#0F2645] hover:border-[#C9D4F4] hover:bg-[#F6F8FD] transition-colors duration-150"
        >
          {expired ? "Activer mon abonnement" : "Voir l'abonnement"}
        </Link>
      ) : (
        <span data-testid="subscription-banner-member" className="text-xs font-semibold text-[#93A0BC]">
          Parlez-en au responsable de la société
        </span>
      )}
    </div>
  );
};
